<template>
  <div class="timeline">
            <div class="timeline__span"><span v-if="showHours">00:00</span></div>
            <div class="timeline__span"><span v-if="showHours">06:00</span></div>
            <div class="timeline__span"><span v-if="showHours">12:00</span></div>
            <div class="timeline__span"><span v-if="showHours">18:00</span></div>
          </div>
</template>

<script>
export default {
  name: 'nx-dayparting-calendar-timeline',
  props: {
    showHours: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
